<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>采购单</el-breadcrumb-item>
            </el-breadcrumb>
        </div>

        <el-card shadow="hover">
            <el-form :inline="true" size="small" v-model="listQuery">
                <el-form-item label="货品申请编号">
                    <el-input v-model="listQuery.applyCode" placeholder="请输入货品申请编号" clearable></el-input>
                </el-form-item>
                <el-form-item label="审核人姓名">
                    <el-input v-model="listQuery.auditName" placeholder="请输入审核人姓名" clearable></el-input>
                </el-form-item>
                <el-form-item label="申请人姓名">
                    <el-input v-model="listQuery.applierName" placeholder="请输入申请人姓名" clearable></el-input>
                </el-form-item>
                <el-form-item label="状态">
                    <el-select v-model="listQuery.status" clearable placeholder="请选择" filterable>
                        <el-option v-for="(item,index) in statusList" :key="index" :label="item.text" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="审核时间">
                    <el-date-picker v-model="listQuery.auditTime" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions"></el-date-picker>
                </el-form-item>
                <el-form-item label="创建时间">
                    <el-date-picker v-model="listQuery.createTime" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions"></el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button icon="el-icon-search" type="primary" plan @click="querySearch">查询</el-button>
                </el-form-item>
            </el-form>

            <!-- 列表数据 -->
            <el-table :data="listData" border style="width: 100%" class="table">
                <el-table-column prop="id" label="ID" width="50px" fixed="left"></el-table-column>
                <el-table-column prop="name" label="采购单名称" fixed="left"></el-table-column>
                <el-table-column prop="purseAmount" label="采购金额"></el-table-column>
                <el-table-column prop="purchaseNo" label="采购单号"></el-table-column>
                 <el-table-column prop="files" label="附件图片" width="150px">
                <template slot-scope="scope">
                    <span v-if="scope.row.purchaseFile==''">无</span>
                    <el-image 
                    v-else
                    slot="reference"
                    :preview-src-list="scope.row.purchaseFile.split(',')"
                    v-for="item in scope.row.purchaseFile.split(',')"
                    :key="item.index"
                    :src="item"
                    ></el-image>
                    </template>
                </el-table-column>
                <el-table-column prop="createUserName" label="申请人"></el-table-column>
                <el-table-column prop="auditName" label="审核人"></el-table-column>
                <el-table-column prop="auditRemark" label="审核备注"></el-table-column>
                <el-table-column prop="auditTime" label="审核时间"></el-table-column>
                <el-table-column prop="status" label="状态">
                    <template slot-scope="scope">
                        {{getStateName(scope.row.status)}}
                    </template>
                </el-table-column>
                <el-table-column prop="wareHouseTime" label="入库时间"></el-table-column>
                <el-table-column prop="finishTime" label="完成时间"></el-table-column>
                <el-table-column prop="remark" label="备注"></el-table-column>
                <el-table-column prop="createTime" label="创建时间"></el-table-column>
                <el-table-column label="操作" fixed="right">
                    <template slot-scope="scope">
                        <el-button type="text" v-per="'purchaseManageReview'" v-if="scope.row.status==2" @click="toAudit(scope.row)" size="mini">审核</el-button>
                        <el-button type="text" @click="toInfo(scope.row)" size="mini">详情</el-button>
                        <el-button type="text" v-per="'postInStock'" v-if="scope.row.status==4" @click="toInStock(scope.row)" size="mini">发起入库</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <pagination :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.size" @pagination="querySearch" />
        </el-card>

        <el-dialog title="采购详情" :visible.sync="visibalDetail" width="800px" :close-on-click-modal="false" center>
            <el-table :data="tempRow.itemList" border class="table" max-height="320" ref="multipleTable">
                <el-table-column prop="purchaseOrderId" label="采购单编号"></el-table-column>
                <el-table-column prop="skuId" label="SKU-ID"></el-table-column>
                <el-table-column prop="commodityName" label="商品名称"></el-table-column>
                 <el-table-column prop="skuSpec" label="规格">
                                
                                <template slot-scope="scope">
                                    <span>{{scope.row.skuSpec[0]}}</span>
                                </template>
                            </el-table-column>
                <el-table-column prop="buyNumber" label="购买数量"></el-table-column>
                <el-table-column prop="purchasePrice" label="采购单价"></el-table-column>
                <el-table-column prop="skuPurchase" label="采购总价"></el-table-column>
            </el-table>
            <p style="padding:20px 0; text-align:right;">合计： {{totalAmount}}</p>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="visibalDetail=false">关闭</el-button>
            </span>
        </el-dialog>

        <el-dialog title="采购单审核" :visible.sync="visibalAduit" width="600px" :close-on-click-modal="false" center>
           <el-table :data="tempRow.itemList" border class="table" max-height="320" ref="multipleTable">
                <el-table-column prop="purchaseOrderId" label="采购单编号"></el-table-column>
                <el-table-column prop="skuId" label="SKU-ID"></el-table-column>
                <el-table-column prop="commodityName" label="商品名称"></el-table-column>
                 <el-table-column prop="skuSpec" label="规格">
                                
                                <template slot-scope="scope">
                                    <span>{{scope.row.skuSpec[0]}}</span>
                                </template>
                            </el-table-column>
                <el-table-column prop="buyNumber" label="购买数量"></el-table-column>
                <el-table-column prop="purchasePrice" label="采购单价"></el-table-column>
                <el-table-column prop="skuPurchase" label="采购总价"></el-table-column>
            </el-table>
            <p style="padding:20px 0; text-align:right;">合计： {{totalAmount}}</p>
            <el-form  style="padding:40px 40px 20px">
                <el-form-item label="审核状态">
                    <el-select v-model="auditData.auditStatus" clearable placeholder="请选择" filterable>
                        <el-option label="通过" value="4"></el-option>
                        <el-option label="不通过" value="3"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="审核原因">
                    <el-input type="textarea" :rows="3" v-model="auditData.auditRemark" placeholder="请填写原因" clearable style="width:360px;"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="visibalAduit=false">关闭</el-button>
                <el-button type="primary" @click="confirmAduit">确认</el-button>
            </span>
        </el-dialog>

        <el-dialog title="采购单入库" :visible.sync="visibalInStock" width="1100px" :close-on-click-modal="false" center>
            <el-form :inline="true">
                <el-form-item label="入库类型">
                    <el-select v-model="inStockData.inHouseType" clearable placeholder="请选择" filterable>
                        <el-option label="部分" value="1"></el-option>
                        <el-option label="全部" value="2"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="备注">
                    <el-input v-model="inStockData.remark" placeholder="请填写备注" clearable></el-input>
                </el-form-item>
            </el-form>

            <el-table :data="skuAndHouseInfoList" @selection-change="handleSelectionChange" border class="table" max-height="320" ref="multipleTable">
                <!-- <el-table-column prop="houseId" label="仓库id"></el-table-column> -->
                <el-table-column type="selection" width="55"> </el-table-column>
                <el-table-column prop="houseName" label="仓库名称"></el-table-column>
                <el-table-column prop="skuCode" label="SKU编码"></el-table-column>
                <el-table-column prop="skuName" label="SKU名称"></el-table-column>
                <el-table-column prop="costPrice" label="成本价格"></el-table-column>
                 <el-table-column prop="numbers" label="商品类型">
                    <template slot-scope="scope">
                      <span>{{salesTypeMap[scope.row.commoditySaleType]}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="numbers" label="入库数量">
                    <template slot-scope="scope">
                        <el-input type="number" v-model.trim="scope.row.numbers"> </el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="codeSn" label="SN码" width="200">
                    <template slot-scope="scope">
                        <template v-for="(item,index) in skuAndHouseInfoList[scope.$index].snList">
                            <span :key="index">{{item}} <br /></span>
                        </template>
                    </template>
                </el-table-column>

                <el-table-column prop="codeSn" label="操作" width="100">
                    <template slot-scope="scope">
                        <!--v-if="scope.row.commoditySaleType==1||scope.row.commoditySaleType==3" -->
                        <el-button type="text" @click="addSn(scope.$index,scope.row)" v-if="scope.row.commoditySaleType==1||scope.row.commoditySaleType==3">完善SN码</el-button>
                    </template>
                </el-table-column> 
            </el-table>

            <span slot="footer" class="dialog-footer">
                <el-button @click="visibalInStock=false">关闭</el-button>
                <el-button type="primary" @click="confirmInStock">提交</el-button>
            </span>
        </el-dialog>

        <el-dialog title="完善SN码" :visible.sync="showAddSn" width="500px" :close-on-click-modal="false" center>

            <el-row>
                <el-form :inline="true" size="small">
                    <el-form-item label="SN码">
                        <el-input v-model="tempSN" placeholder="请输入SN码" clearable></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" plan @click="confirmSn">暂存</el-button>
                    </el-form-item>
                </el-form>
            </el-row>
            <el-row style="text-align:center;font-size:18px;">
                <template v-for="(item,index) in tempSNList">
                    <span :key="index">{{item}}
                        <el-button type="text" plan @click="delRow(index)">删除</el-button>
                        <br />
                    </span>
                </template>
            </el-row>

            <span slot="footer" class="dialog-footer">
                <el-button @click="confirmSnAdd">确定</el-button>
            </span>
        </el-dialog>

    </div>
</template>
<script>
import moment from "moment";
import Pagination from "../common/Pagination";
import wmsApi from "@/script/api/wmsApi";
import globalData from "@/components/common/globaldata/global.data.vue";
import "./css/index.css";

export default {
    components: { Pagination },
    data() {
        return {
            totalAmount:0,
            salesTypeMap: {
                1: "租借",
                2: "售卖",
                3: "租借和售卖",
                4: "补贴",
            },
            showAddSn: false,
            tempSN: null,
            visibalDetail: false, //详情
            visibalAduit: false, //审核
            visibalInStock: false, //发起入库
            tempRow: {},
            tempIndex: null,
            tempSNList: [],
            auditData: {
                //审核数据
                purchaseOrderId: null,
                auditStatus: null,
                auditRemark: null,
            },
            skuAndHouseInfoList: [], //列表多选框
            inStockData: {
                //入库
                inHouseType: null,
                purchaseId: null,
                remark: null,
                goodsList: [],
            },
            total: 0,
            listData: [],
            listQuery: {
                createTime: [],
                auditTime: [],
                page: 1,
                size: 10,
                applyCode: null,
                status: null,
                auditTimeStart: null,
                auditTimeEnd: null,
                auditName: null,
                applierName: null,
                createTimeStart: null,
                createTimeEnd: null,
            },
            statusList: [
                {
                    id: 1,
                    text: "编辑中",
                },
                {
                    id: 2,
                    text: "待审核",
                },
                {
                    id: 3,
                    text: "审核不通过",
                },
                {
                    id: 4,
                    text: "审核通过",
                },
                {
                    id: 5,
                    text: "待入库",
                },
                {
                    id: 6,
                    text: "已入库",
                },
                {
                    id: 7,
                    text: "待结算",
                },
                {
                    id: 8,
                    text: "已结算",
                },
                {
                    id: 9,
                    text: "已完成",
                },
                {
                    id: 10,
                    text: "关闭",
                },
                {
                    id: 11,
                    text: "部分入库",
                },
            ],
            pickerOptions: {
                shortcuts: [
                    {
                        text: "最近一周",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(
                                start.getTime() - 3600 * 1000 * 24 * 7
                            );
                            picker.$emit("pick", [start, end]);
                        },
                    },
                    {
                        text: "最近半个月",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(
                                start.getTime() - 3600 * 1000 * 24 * 15
                            );
                            picker.$emit("pick", [start, end]);
                        },
                    },
                    {
                        text: "最近一月",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(
                                start.getTime() - 3600 * 1000 * 24 * 30
                            );
                            picker.$emit("pick", [start, end]);
                        },
                    },
                ],
            },
        };
    },
    created() {
        this.querySearch();
    },
    methods: {
        delRow(index) {
            console.log("删除");
            this.tempSNList.splice(index, 1);
        },
        purchaseSum(arr){
            console.log(arr);
          let s = 0;
          let len=arr.length;
       for (let i=len-1; i>=0; i--) {
        s += arr[i].skuPurchase;
        }
          return s.toFixed(2);
        },
        confirmSnAdd() {
            this.skuAndHouseInfoList[this.tempIndex].snList = this.tempSNList;
            this.$set(
                this.skuAndHouseInfoList,
                this.tempIndex,
                this.skuAndHouseInfoList[this.tempIndex]
            );
            this.showAddSn = false;
        },
        confirmSn() {
            if(this.tempSN==''||this.tempSN==null){
                return;
            }
            if (this.isInArray(this.tempSNList, this.tempSN)) {
                this.$message.error("SN码重复");
                return;
            }
            if (this.tempSNList.length>=this.tempRow.numbers ) {
                this.$message.error("已达到入库数量");
                return;
            }
            this.tempSNList.push(this.tempSN);
            this.tempSN = null;
        },
        addSn(index, row) {
            console.log(index);

            this.showAddSn = true;
            this.tempSNList = row.snList;
            this.tempRow=row;
            this.tempIndex = index;
             this.tempSN = null;
        },
        confirmInStock() {
            //提交采购入库单
            if (
                this.inStockData.inHouseType == null ||
                this.inStockData.inHouseType == ""
            ) {
                this.$message.error("选择入库类型");
                return;
            }
            if (this.inStockData.goodsList.length == 0) {
                this.$message.error("请选择列表sku信息");
                return;
            }

            let boo=true;
            let err="";
            this.inStockData.goodsList.forEach(e=>{
                if(e.commoditySaleType==1||e.commoditySaleType==3){
                    //有租赁,一定判断sn数量=入库数量
                    if(e.snList.length!=e.numbers){
                        boo=false;
                        err=e.skuName+','+e.costPrice
                    }
                }
                e.codeSn=e.snList.join(","); 
            })
            if(!boo){
                this.$message.error("租赁商品需完善SN码："+err);
                return;
            }

            wmsApi
                .$axioswmsPurchaseprocurementAndWarehousing(this.inStockData)
                .then((res) => {
                    if (res.data.errno == 0) {
                        this.$message.success("操作成功");
                        this.visibalInStock = false;
                        this.querySearch();
                    } else {
                        this.$message.error(res.data.data);
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        handleSelectionChange(val) {
            console.log(val);
            this.inStockData.goodsList = val;
        },
        toInStock(row) {
            //发起入库弹窗
            this.tempRow = row;
            this.visibalInStock = true;
            this.inStockData = {
                inHouseType: null,
                purchaseId: row.id,
                remark: null,
                goodsList: [],
            };
            this.querySkuAndHouseInfo(row);
        },
        querySkuAndHouseInfo(row) {
            this.skuAndHouseInfoList = [];
            wmsApi
                .$axioswmsPurchasequerySkuAndHouseInfo({
                    purchaseOrderId: row.id,
                })
                .then((res) => {
                    if (res.data.errno == 0) {
                        this.skuAndHouseInfoList = res.data.data;
                        this.skuAndHouseInfoList.forEach((e) => {
                            e.snList = [];
                        });
                    } else {
                        this.$message.error(res.data.data);
                    }
                });
        },
        confirmAduit() {
            //确认审核
            if (
                this.auditData.auditStatus == "" ||
                this.auditData.auditStatus == null
            ) {
                this.$message.error("请选择审核状态");
                return;
            }
            if (
                this.auditData.auditStatus == 3 &&
                (this.auditData.auditRemark == null ||
                    this.auditData.auditRemark == "")
            ) {
                this.$message.error("请填写原因");
                return;
            }

            wmsApi
                .$axioswmsPurchaseauditPurchaseOrdert(this.auditData)
                .then((res) => {
                    if (res.data.errno == 0) {
                        this.$message.success("操作成功");
                        this.visibalAduit = false;
                        this.querySearch();
                        // this.querySearch();
                    } else {
                        this.$message.error(res.data.data);
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        toAudit(row) {
            //审核弹窗
            this.tempRow = row;
            this.visibalAduit = true;
            this.auditData = {
                purchaseOrderId: row.id,
                auditStatus: null,
                auditRemark: null,
            };
             this.totalAmount=this.purchaseSum(this.tempRow.itemList);
        },
        toInfo(row) {
            //详情
            this.tempRow = row;
            this.visibalDetail = true;
            this.totalAmount=this.purchaseSum(this.tempRow.itemList);
        },
        querySearch() {
            console.log(this.listQuery);
            if (this.listQuery.auditTime.length > 0) {
                this.listQuery.auditTimeStart = this.listQuery.auditTime[0]
                    .getTime()
                    .toString()
                    .substr(0, 10);
                this.listQuery.auditTimeEnd = this.listQuery.auditTime[1]
                    .getTime()
                    .toString()
                    .substr(0, 10);
            } else {
                this.listQuery.auditTimeStart = null;
                this.listQuery.auditTimeEnd = null;
            }
            if (this.listQuery.createTime.length > 0) {
                this.listQuery.createTimeStart = this.listQuery.createTime[0]
                    .getTime()
                    .toString()
                    .substr(0, 10);
                this.listQuery.createTimeEnd = this.listQuery.createTime[1]
                    .getTime()
                    .toString()
                    .substr(0, 10);
            } else {
                this.listQuery.createTimeStart = null;
                this.listQuery.createTimeEnd = null;
            }

            wmsApi
                .$axioswmsPurchasepurchaseOrderList(this.listQuery)
                .then((res) => {
                    this.listData = res.data.data.list;
                    this.total = res.data.data.total;
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        getStateName(status) {
            let stateName = "";
            this.statusList.forEach((e) => {
                if (e.id == status) {
                    stateName = e.text;
                }
            });
            return stateName;
        },
        isInArray(arr, value) {
            for (var i = 0; i < arr.length; i++) {
                if (value === arr[i]) {
                    return true;
                }
            }
            return false;
        },
    },
};
</script>



<style scoped>
.crumbs {
    margin: 0 0 10px 0;
}
.btn-margin .el-button--small {
    margin: 10px 12px 0 0;
}
.el-image img {
    height: 60px;
    width: 60px;
    margin: 0 12px 12px 0;
    object-fit: cover;
}
</style>
